<div class="mtn-container">
    <div class="mtn-title">
        <p>{{ moduleName?.toUpperCase() }}</p>
    </div>
    
    <div *ngIf="showForm" class="form-content">
        <form [formGroup]="forms.filterLovForm" class="form">
            <div class="form-container-grid top-form">
                <div class="field required">
                    <label>Line</label>
                </div>
                <div class="">
                    <input formControlName="lineCdDisp">
                    <button matSuffix class="btn btn-search" type="button" (click)="openLov['line']()" [disabled]="btns.filterLov.lineLovSearchDisabled"
                         >
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
                <div class="field required">
                    <label>Subline</label>
                </div>
                <div class="">
                    <input formControlName="sublineCdDisp">
                    <button matSuffix class="btn btn-search" type="button" (click)="openLov['subline']()" [disabled]="btns.filterLov.sublineLovSearchDisabled"
                         >
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
                <div class="field required">
                    <label>Plan</label>
                </div>
                <div class="">
                    <input formControlName="planDisp">
                    <button matSuffix class="btn btn-search" type="button" (click)="openLov['plan']()" [disabled]="btns.filterLov.planLovSearchDisabled"
                         >
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
                <div class="field required">
                    <label>User Type</label>
                </div>
                <div class="">
                    <select formControlName="userType" (change)="checkSelects();changeQuotationWordings()">
                        <option *ngFor="let userTypeView of userTypeViewList" [value]="userTypeView.rvLowValue">{{userTypeView.rvLowValue + ' - ' + userTypeView.rvMeaning }}</option>
                    </select>
                </div>
                <div class="field required">
                    <label>Wording Type</label>
                </div>
                <div class="">
                    <select formControlName="wordingType" (change)="checkSelects();changeQuotationWordings()">
                        <option *ngFor="let wordingTypeView of wordingTypeList" [value]="wordingTypeView.rvLowValue">{{ wordingTypeView.rvLowValue + ' - ' + wordingTypeView.rvMeaning }}</option>
                    </select>
                </div>
            </div>
        </form>
    </div>
    <osp-table [tblConfig]="quotationWordingsTblConfig" (onRowClick)="onRowClick($event)" [selectedRow]="selectedRow"></osp-table>
    <div id="quotation-wordings-maintenance-loading">
        <div class="form-loader"></div>
    </div>
    <div *ngIf="showForm" class="form-content">
        <form [formGroup]="forms.quotationWordingsForm" class="form">
            <div id="quotation-wordings-error-message"></div>
            <div class="form-container-grid">
                <div class="field required">
                    <label>Wording Code</label>
                </div>
                <div class="">
                    <input formControlName="wordingCd" maxlength="4" alphanumeric >
                </div>
                <div class="field required">
                    <label>Active</label>
                </div>
                <div class="">
                    <select formControlName="active">
                        <option *ngFor="let activeType of selections.activeTypes" [value]="activeType.cd">
                            {{activeType.name}}
                        </option>
                    </select>
                </div>
                <div class="field required">
                    <label>Title</label>
                </div>
                <div class="span">
                    <input formControlName="title" maxlength="100" >
                </div>
                <div class="field">
                    <label>Subtitle</label>
                </div>
                <div class="span">
                    <input formControlName="subtitle" maxlength="100" >
                </div>
                <div class="field">
                    <label>Bullet No.</label>
                </div>
                <div class="">
                    <input formControlName="bulletNo" maxlength="10" alphanumeric >
                </div>
                <div class="field">
                    <label>Sequence No.</label>
                </div>
                <div class="">
                    <input formControlName="seqNo"  (input)="numOnlyPattern($event)">
                </div>
                <div class="field required">
                    <label>Wordings</label>
                </div>
                <div class="span">
                    <textarea formControlName="wordings" maxlength="4000"></textarea>
                </div>
                <div class="field">
                    <label>Remarks</label>
                </div>
                <div class="span">
                    <input formControlName="remarks" maxlength="4000" >
                </div>
                <div class="field">
                    <label>Last Update User</label>
                </div>
                <div class="">
                    <input formControlName="lastUpdateUser" >
                </div>
                <div class="field">
                    <label>Last Update</label>
                </div>
                <div class="">
                    <input formControlName="lastUpdate" >
                </div>
            </div>
        </form>
        <div class="btn-grp">
            <button *ngIf="btns.quotationWordings.updateDisabled" class="btn btn2" type="button" (click)="onAdd()" [disabled]="btns.quotationWordings.addDisabled" >ADD</button>
            <button *ngIf="!btns.quotationWordings.updateDisabled" class="btn btn2" type="button" (click)="onUpdate()" >UPDATE</button>
            <button class="btn btn2" type="button" [disabled]='btns.quotationWordings.deleteDisabled' (click)="onDelete()" >DELETE</button>
        </div>
        <div class="mtn-title"></div>
        <div class="btn-grp">
            <button class="btn btn2" type="button" [disabled]='btns.quotationWordings.saveDisabled' (click)="onSave()" >SAVE</button>
        </div>
    </div>
</div>
